import { SECTIONS, anchor } from '@/constants';
import type { NavGroup, NavItem } from '@/types';

/**
 * In-page anchors: the header scrolls, it does not navigate.
 *
 * The main sections of the page, in the order they appear, so the nav doubles
 * as a table of contents and the scroll-spy highlight moves top to bottom as
 * the reader goes down. The header derives the ids it tracks from this list,
 * so adding an entry here is all that is needed — see `Header.tsx`.
 */
export const PRIMARY_NAV: readonly NavItem[] = [
  { label: 'The problem', to: anchor(SECTIONS.problem) },
  { label: 'How it works', to: anchor(SECTIONS.howItWorks) },
  { label: 'The platform', to: anchor(SECTIONS.platform) },
  { label: 'For manufacturers', to: anchor(SECTIONS.manufacturers) },
  { label: 'For retailers', to: anchor(SECTIONS.retailers) },
  // Parked with section 08 — see src/pages/HomePage/HomePage.tsx.
  // { label: 'Start a pilot', to: anchor(SECTIONS.pilot) },
  // Parked with the FAQ section — see src/pages/HomePage/HomePage.tsx.
  // { label: 'FAQ', to: anchor(SECTIONS.faq) },
];

export const FOOTER_NAV: readonly NavGroup[] = [
  {
    title: 'Platform',
    items: [
      { label: 'How it works', to: anchor(SECTIONS.howItWorks) },
      { label: 'For manufacturers', to: anchor(SECTIONS.manufacturers) },
      // Parked with section 08 — see src/pages/HomePage/HomePage.tsx.
      // { label: 'Start a pilot', to: anchor(SECTIONS.pilot) },
      { label: 'Contact', to: anchor(SECTIONS.contact) },
    ],
  },
];
